import { useI18n } from '@mcex/locale';
import { useMessage } from '/@/hooks/web/useMessage';
import { useNetwork } from '@vueuse/core';
import { watch } from 'vue';

export const useCheckNetwork = () => {
  const { isSupported, isOnline, rtt } = useNetwork();
  const { notification } = useMessage();
  const { t } = useI18n();
  watch(
    () => [isOnline.value, rtt.value],
    ([online, speed]) => {
      if (!isSupported.value) {
        return;
      }
      if (!online) {
        notification.warning({
          placement: 'bottomRight',
          message: t('sys.exception.networkErrorSubTitle'),
        });
      }
      if (speed && (speed as number) > 500) {
        notification.warning({
          placement: 'bottomRight',
          message: t('sys.api.networkExceptionMsg'),
        });
      }
    },
    {
      immediate: true,
    },
  );
};
